import React from 'react';
import { string, func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { URI } from '@fiverr-private/futile';
import { Section, Button } from '@fiverr-private/fit';

import './index.scss';

const MARKETPLACE_SOURCE = 'entire_marketplace_link';
const SEARCH_FILTER = 'auto';

export const MarketplaceLink = ({ href, onClick }) => {
    const uri = new URI(href).addParams({
        source: MARKETPLACE_SOURCE,
        filter: SEARCH_FILTER
    });

    return (
        <Section className="marketplace-link">
            <h4><I18n k="search_perseus.marketplace.text"/></h4>
            <Button color="pro" size="large" href={uri.href} onClick={onClick}>
                <I18n k="search_perseus.marketplace.cta"/>
            </Button>
        </Section>
    );
};

MarketplaceLink.propTypes = {
    href: string,
    onClick: func
};
